import { render } from "./Spaces.vue?vue&type=template&id=37b677d0&scoped=true"
import script from "./Spaces.vue?vue&type=script&lang=js"
export * from "./Spaces.vue?vue&type=script&lang=js"

import "./Spaces.vue?vue&type=style&index=0&id=37b677d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b677d0"]])

export default __exports__